import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

const ItemNumberValue = ({ labelText }) => {
  const {
    BidStore: { auction },
  } = useStores();

  const { lotNumber } = auction;
  const label = labelText ? `${labelText} ` : '# ';
  const labelWithLotNumber = lotNumber ? `${label}${lotNumber}` : label;
  const labelValue = labelWithLotNumber === '#' ? 'No Item On Block' : labelWithLotNumber;

  return (
    <h1 data-testid="lotnumber">
      {labelValue}
    </h1>
  );
};

ItemNumberValue.propTypes = {
  labelText: PropTypes.string,
};

ItemNumberValue.defaultProps = {
  labelText: null,
};

export default observer(ItemNumberValue);
